import {Button, Image, Input, Radio, Toast} from "antd-mobile";
import {useState} from "react";
import {TOASTDURATION} from "../../common/Utils";
import {payCreate} from "../../common/ApiAction";
import {useNavigate} from "react-router-dom";

const Wave = () => {
    const navigate = useNavigate()
    const [payAmount, setPayAmount] = useState<string>('')
    const [telephone, setTelephone] = useState<string>('')
    const [customerRemarks, setCustomerRemarks] = useState<string>('')
    const [countryCode, setCountryCode] = useState<string>('')

    const sumbitAction = () => {
        if (!countryCode) {
            Toast.show({content: "Veuillez sélectionner le pays", duration: TOASTDURATION})
            return
        }
        if (!telephone.trim()) {
            Toast.show({content: "Veuillez entrer le numéro", duration: TOASTDURATION})
            return
        }
        if (!payAmount.trim()) {
            Toast.show({content: "Veuillez entrer le montant", duration: TOASTDURATION})
            return
        }
        Toast.show({icon: 'loading', content: 'Processing...', duration: 0})
        const data = {
            paymentMethod: 'WAVE_API',
            amount: payAmount.trim(),
            phoneNumber: telephone.trim(),
            customData: customerRemarks.trim(),
            countryCode: countryCode === '221' ? 'SN': 'CI',
            networkType: ''
        }
        payCreate(data).then((res: any) => {
            Toast.clear();
            if (parseInt(res.code) !== 200) {
                Toast.show({icon: 'fail', content: res.message || res.msg, duration: TOASTDURATION})
            } else {
                navigate('/mtnAndMoov', {state: res.data});
            }
        })
    }
    return (
        <div style={{width: '100%', display: "flex", flexDirection: "column", alignItems: "center"}}>
            <div>
                <Image src={require('../../assets/icon_ego_logo.jpg')} style={{width: 100}}/>
            </div>
            <div style={{borderRadius: 8, padding: '50px 0 20px 0', border: "solid #08ad58 1px", width: '90%', marginTop: 15, display: "flex", flexDirection: "column", alignItems: "center"}}>
                <span style={{fontSize: 20, fontWeight: "bold",marginBottom: 30}}>Centre de paiement</span>
                <div style={{display: "flex", flexDirection: "column", justifyContent: "start", width: '100%'}}>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 30}}>
                        <span style={{fontSize: 12, marginRight: 10, width: 110}}>Pays:</span>
                        <Radio.Group value={countryCode} onChange={val => setCountryCode(val as string)}>
                            <Radio style={{'--font-size': '12px', '--gap': '6px', '--icon-size': '15px'}} value="221">Sénégal (+221)</Radio>
                            <Radio style={{'--font-size': '12px', '--gap': '6px', '--icon-size': '15px', marginLeft: 10}} value="225">Côte d'Ivoire (+225)</Radio>
                        </Radio.Group>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 30}}>
                        <span style={{fontSize: 12, marginRight: 10, width: 110}}>Votre numéro: + {countryCode}</span>
                        <Input onChange={val => setTelephone(val)} type={'number'} style={{"--font-size": '12px', width: '45%', border: "solid #cccccc 1px"}} placeholder={"numéro de téléphone"}/>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 30}}>
                        <span style={{fontSize: 14, marginRight: 10, width: 110}}>Montant:</span>
                        <Input onChange={val => setPayAmount(val)} type={'number'} style={{"--font-size": '10px', width: '45%', border: "solid #cccccc 1px"}} placeholder={"Montant"}/>
                        <span style={{fontSize: 14, marginRight: 10, marginLeft: 5}}>FCFA</span>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: 20, marginLeft: 30}}>
                        <span style={{fontSize: 14, marginRight: 10, width: 110}}>Numéro Identifiant:</span>
                        <Input value={customerRemarks} onChange={val => setCustomerRemarks(val)} type={'text'} style={{"--font-size": '10px', width: '45%', border: "solid #cccccc 1px"}} placeholder={"Numéro Identifiant"}/>
                    </div>
                </div>
            </div>
            <div>
                <Button shape='rounded' style={{backgroundColor: '#08ad58', color: '#FFF', marginTop: 50, paddingLeft: 30, paddingRight: 30}} onClick={sumbitAction}>Confirmer et procéder</Button>
            </div>
        </div>
    )
}
export default Wave
